import { combineEpics } from 'redux-observable';
import { addLayoutRootEpic } from './addLayoutRootEpic';
import { loadBirdModelEpic } from './loadBirdModelEpic';

export const rootEpic = combineEpics(addLayoutRootEpic, loadBirdModelEpic);
